import { type Group } from "@entities";
import type { EventInput } from "@fullcalendar/core";
import { formatOpportunitySchedule } from "@shared/helpers/format-opportunity-schedule";
import dayjs from "dayjs";

export function processString(txt: string): {
  beforeNumber: string;
  afterNumber: string;
} {
  function findFirstNumberIndex(txt: string) {
    const regex = /\d/;
    const match = txt.match(regex);
    return match ? match.index : -1;
  }
  const numberIndex = findFirstNumberIndex(txt);
  if (numberIndex === -1) {
    return { beforeNumber: txt, afterNumber: "" };
  }
  const beforeNumber = txt.substring(0, numberIndex);
  const afterNumber = txt.substring(numberIndex!);
  return { beforeNumber, afterNumber };
}

export function getGroups(groups: Group[], isEvents: boolean): EventInput[] {
  if (groups.length === 0) return [];

  if (isEvents) {
    return groups.flatMap(group => {
      return group?.opportunities?.filter(opp => opp.opportunity?.title).map(({ opportunity: event }) => {
        return {
          title:
            `${event?.title} | ${event ? formatOpportunitySchedule(event) : ""} - ${group.name}`,
          date:
            event?.startDate ??
            event?.endDate ??
            group.preferredStartDate ??
            undefined,
          backgroundColor: "#74c476",
          textColor: "black",
          borderColor: "white",
          allDay: true,
          id: event?.id,
          interactive: false,
        };
      }) || [];
    });
  }

  return groups.flatMap<EventInput, EventInput[]>((group) => {
    if (!group || !group.preferredStartDate) return [];

    const title = String(group.name);
    const backgroundColor = group.status?.color || "purple";

    if (group.preferredEndDate && !dayjs(group.preferredStartDate).isSame(group.preferredEndDate, 'day')) {
      return [
        {
          title,
          start: group.preferredStartDate,
          end: group.preferredEndDate,
          backgroundColor,
          textColor: "black",
          borderColor: "white",
          allDay: false,
          id: group.id,
          interactive: false,
        },
      ];
    } else {
      return [
        {
          title,
          date: group.preferredStartDate,
          backgroundColor,
          textColor: "black",
          borderColor: "white",
          allDay: true,
          id: group.id,
          interactive: false,
        },
      ];
    }
  });
}
